import { render, staticRenderFns } from "./clubCard.vue?vue&type=template&id=ba36243c&"
import script from "./clubCard.vue?vue&type=script&lang=js&"
export * from "./clubCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports